<!-- Barra de acciones: Usa estilos Bootstrap como el diseño original -->
<div class="d-flex width-100 justify-content-between align-items-center">
  <!-- Sección izquierda: Cambio de estado masivo -->
  <div class="d-flex align-items-center">
    <button
      class="btn btn-secundario"
      type="button"
      *ngIf="selectedCount > 0"
      [disabled]="!canChangeStatus()"
      (click)="onChangeStatusSelected()"
      [matTooltip]="'tooltip.change_status' | translate">
      {{ "buttons.change_stage" | translate }}
    </button>
    <span
      *ngIf="selectedCount > 0"
      class="ms-3 text-muted text-base">
      {{ selectedCount }} {{ 'table.selected' | translate }}
    </span>
  </div>

  <!-- Sección derecha: Importar, Exportar, Paginador -->
  <div class="d-flex align-items-center" style="gap: 10px">
    <button
      class="btn btn-secundario action-btn"
      type="button"
      *ngIf="canImport()"
      (click)="onImportData()"
      [matTooltip]="'tooltip.import_data' | translate">
      <span class="action-btn-text">{{ "buttons.import" | translate }}</span> <i class="icon-upload"></i>
    </button>

    <button
      class="btn btn-secundario action-btn"
      type="button"
      (click)="onExportAll()"
      [matTooltip]="'tooltip.export_all' | translate">
      <span class="action-btn-text">{{ "buttons.export" | translate }}</span> <i class="icon-download"></i>
    </button>

    <!-- Slot para paginador (se pasa desde el componente padre) -->
    <ng-content select="[paginator]"></ng-content>
  </div>
</div>
